<div class="profile-content">
  <div class="row">
    <div class="col-md-12">
      <div class="caption caption-md">
        <i class="icon-globe theme-font hide"></i>
        <span class="caption-subject">Account overview</span>
        <span class="caption-sub-subject">Your profile</span>
      </div>
    </div>
    <div class="portlet-body">
      <div class="table-responsive">
        <table class="table">
          <tbody>
            <tr>
              <td class="subjectwidth">First name</td>
              <td class="fields-text">{{ userProfileOverview?.firstName }}</td>
            </tr>
            <tr>
              <td class="subjectwidth">Last name</td>
              <td class="fields-text">{{ userProfileOverview?.lastName }}</td>
            </tr>
            <tr>
              <td class="subjectwidth">Organization</td>
              <td class="fields-text">{{ userProfileOverview?.organizationName }}</td>
            </tr>
            <tr>
              <td class="subjectwidth">License level</td>
              <td class="fields-text">{{ userProfileOverview?.licenseLevel }}</td>
            </tr>
            <tr>
              <td class="subjectwidth">Email</td>
              <td>
                <a [attr.href]="'mailto:' + userProfileOverview?.userName" class="fields-text">
                  {{ userProfileOverview?.userName }}</a
                >
              </td>
            </tr>
            <tr>
              <td class="subjectwidth">Phone</td>
              <td class="fields-text">{{ userProfileOverview?.phone }}</td>
            </tr>
            <tr>
              <td class="subjectwidth">Post code</td>
              <td class="fields-text">{{ userProfileOverview?.postCode }}</td>
            </tr>
            <tr>
              <td class="subjectwidth">Country</td>
              <td class="fields-text">{{ userProfileOverview?.countryName }}</td>
            </tr>
            <tr>
              <td class="subjectwidth">State</td>
              <td class="fields-text">{{ userProfileOverview?.stateName | titlecase }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
